<odq-dialog
  [showCancelButton]="false"
  [bindXButtonToExternalEventHandler]="true"
  (buttonXClicked)="cancel()"
  >
  <odq-dialog-title style="padding: 0px;">
    <div class="title-container">
      <mat-icon class="help-topic-icon">help</mat-icon>&nbsp;&nbsp;
      {{ helpTopic?.title }}
    </div>
  </odq-dialog-title>

  <odq-dialog-content>
    @if (isLoading$ | async) {
      <odq-loading-spinner class="loading-spinner"></odq-loading-spinner>
    } @else {
      <p>
        <span class="help-topic-content" [innerHTML]="formatHelpTopicHtml(helpTopic?.userHelpText) | sanitizeHtml"></span>
      </p>
    }
  </odq-dialog-content>

  <odq-dialog-actions>
    <div class="button-container">
      <button mat-raised-button class="close-button" type="button" (click)="cancel()">
        {{ 'help_topic_viewer_dialog.close' | translate }}
      </button>
    </div>
  </odq-dialog-actions>
</odq-dialog>


